import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { SpecialDealsBoard } from '@api/BoardSDK';
import { withBoardAuth } from './boardAuth.server';

/** Current deals marked "Show on Portal" (up to 20), soonest-first by Sort Order; expired ones are skipped. */
export const getDeals = createServerFn({ method: 'GET' })
  .validator(z.object({}).optional())
  .handler(async () => withBoardAuth(async () => {
    const res = await new SpecialDealsBoard().items()
      .withColumns(['description', 'paper', 'dealPrice', 'regularPrice', 'validUntil', 'sortOrder', 'showOnPortal'])
      .where({ showOnPortal: true })
      .orderBy({ column: 'sortOrder', direction: 'asc' })
      .withPagination({ limit: 20 })
      .execute();
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const items = (res?.items ?? []).filter((d) => !d.validUntil || new Date(d.validUntil).getTime() >= today.getTime())
      .map((d) => ({ id: d.id, name: d.name, description: d.description, paper: d.paper, dealPrice: d.dealPrice, regularPrice: d.regularPrice, validUntil: d.validUntil ? new Date(d.validUntil).toISOString() : null }));
    return { items };
  }));
